import Vue from 'vue'
import { ValidationObserver, ValidationProvider, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import { confirmed, required, numeric, email, min, max } from 'vee-validate/dist/rules'

export default function() {
  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)

  extend('password', {
    message: '半角英数字を各1種類以上含めてください',
    validate: value => {
      if (!value.match(/\d/)) return false;
      if (!value.match(/[A-Za-z]/)) return false;
      return true;
    }
  })

  extend('confirmed', { ...confirmed })
  extend('required', { ...required })
  extend('numeric', { ...numeric })
  extend('email', { ...email })
  extend('min', { ...min })
  extend('max', { ...max })

  localize('ja', ja)
}
